import { makeApiUrl } from '@/main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '@/main/factories/decorators';
import { RemoteManageActivities } from '@/data/usecases/remote-manage-activities';
export const makeRemoteManageActivities = () => {
    return new RemoteManageActivities(makeApiUrl(`/activities`), makeAuthorizeHttpClientDecorator());
};
